import TopMenu from '../../components/TopMenu/TopMenu.vue'
import Footer from '../../components/Footer/Footer.vue'

export default {
  data: function() {
    return {
      language: this.$store.getters.language,
      supportedLanguages: this.$store.getters.supportedLanguages
    }
  },
  computed: {
    menu: function() {
      let structure = [
        {
          h3: 'Sampling & Delivery Services'
        },
        {
          h5: 'Hazardous products'
        },
        {
          link: 'Liquid bulk',
          href: 'liquid-bulk',
          description: 'Reliable and accurate samples of liquid bulk can only be guaranteed when using accredited sampling methods. With our extensive knowledge of petrochemicals we can advise the type of samples that need to be taken in order to have a sample from with accurate and reliable data can be gathered.',
          icons: [
            {
              href: '/static/images/services/blue/vessel-barge.png',
              description: 'Vessel / barge'
            },
            {
              href: '/static/images/services/blue/shore-tank.png',
              description: 'Shore tank'
            },
            {
              href: '/static/images/services/blue/truck.png',
              description: 'Truck'
            },
            {
              href: '/static/images/services/blue/railcar.png',
              description: 'Railcar'
            },
            {
              href: '/static/images/services/blue/ibc.png',
              description: 'IBC'
            }
          ]
        },
        {
          link: 'Dry bulk',
          href: 'dry-bulk',
          description: 'Our services support you in obtaining a sample that is truly representative of the whole cargo.' +
          '<br/><br/>' +
          'With our tested equipment and professional staff we are able to collect the correct sample you need.',
          icons: [
            {
              href: '/static/images/services/blue/vessel-barge.png',
              description: 'Vessel / barge'
            },
            {
              href: '/static/images/services/blue/silo.png',
              description: 'Silo'
            },
            {
              href: '/static/images/services/blue/warehouse.png',
              description: 'Warehouse'
            },
            {
              href: '/static/images/services/blue/container.png',
              description: 'Container'
            }
          ]
        },
        {
          link: 'Medical',
          href: 'medical',
          description: 'Transporting samples in the healthcare sector is not simple. Blood and biological samples require extreme care with temperature management. Our delivery service can help prevent delays to ensure results are not compromised. With our experience, reaction speed and 24/7 availability we can assure your samples will arrive on time and in perfect condition.'
        },
        {
          link: 'Waste water',
          href: 'waste-water',
          description: 'Personal safety is always key! Sampling of waste water can only be done by qualified personnel. Our staff is trained and take due care to avoid personal injury arising from the origin of the sample itself or the location of the sample point. Collected samples are securely sealed, clearly labeled and safely transported (in cooler boxes where necessary).'
        },
        {
          h5: 'Non-hazardous products'
        },
        {
          link: 'FOSFA - minerals & free flowing products',
          href: 'fosfa-minerals-free-flowing-products',
          description: 'FOSFA materials are very delicate. Contamination can easily occur when using non-dedicated sampling material. With our tested FOSFA dedicated equipment we assure our clients the samples taken are precise and reliable. Whether it’s grains, vegetable oils, seeds or any other food commodities – QSDS can help you verify the quality of your product by providing representative samples.',
          icons: [
            {
              href: '/static/images/services/blue/vessel-barge.png',
              description: 'Vessel / barge'
            },
            {
              href: '/static/images/services/blue/silo.png',
              description: 'Silo'
            },
            {
              href: '/static/images/services/blue/warehouse.png',
              description: 'Warehouse'
            },
            {
              href: '/static/images/services/blue/container.png',
              description: 'Container'
            },
            {
              href: '/static/images/services/blue/shore-tank.png',
              description: 'Shore tank'
            },
            {
              href: '/static/images/services/blue/truck.png',
              description: 'Truck'
            },
            {
              href: '/static/images/services/blue/railcar.png',
              description: 'Railcar'
            },
            {
              href: '/static/images/services/blue/ibc.png',
              description: 'IBC'
            }
          ]
        },
        {
          link: 'Bulk granular or powder',
          href: 'bulk-granular-or-power',
          description: 'In order to control the quality of the end product, bulk granular or powder needs to be sampled on a frequent basis during process operations. Our sampling engineers are trained to monitor the different steps of a process and know when samples should be taken in order to represent the end product.',
          icons: [
            {
              href: '/static/images/services/blue/vessel-barge.png',
              description: 'Vessel / barge'
            },
            {
              href: '/static/images/services/blue/silo.png',
              description: 'Silo'
            },
            {
              href: '/static/images/services/blue/warehouse.png',
              description: 'Warehouse'
            }
          ]
        },
        {
          link: 'Environmental',
          href: 'environmental',
          description: 'Sampling soil or groundwater requires trained hands. A sample can quickly become useless if it\'s not taken by an experienced professional using the correct equipment. We offer services of the highest standard. Our main goal is to help our customers identify issues swiftly and efficiently. Contact us to find out more about our sampling and delivery service.',
          icons: [
            {
              href: '/static/images/services/blue/soil.png',
              description: 'Soil'
            },
            {
              href: '/static/images/services/blue/groundwater.png',
              description: 'Groundwater'
            }
          ]
        }
      ]

      switch (this.language.value) {
        case 'nl':
          structure = [
            {
              h3: 'Staalname & Transport Diensten'
            },
            {
              h5: 'Gevaarlijke producten'
            },
            {
              link: 'Vloeibare bulk',
              href: 'vloeibare-bulk',
              description: 'Betrouwbare en accurate stalen van vloeibare bulk kunnen enkel gegarandeerd worden door geaccrediteerde staalname methodes. Met onze uitgebreide kennis van petrochemische producten kunnen we adviseren welke types stalen genomen moeten worden om van een staal accuracte en betrouwbare data te kunnen verzamelen.',
              icons: [
                {
                  href: '/static/images/services/blue/vessel-barge.png',
                  description: 'Vaartuig / Binnenschip'
                },
                {
                  href: '/static/images/services/blue/shore-tank.png',
                  description: 'Land tank'
                },
                {
                  href: '/static/images/services/blue/truck.png',
                  description: 'Vrachtwagen'
                },
                {
                  href: '/static/images/services/blue/railcar.png',
                  description: 'Wagon'
                },
                {
                  href: '/static/images/services/blue/ibc.png',
                  description: 'IBC'
                }
              ]
            },
            {
              link: 'Droge bulk',
              href: 'droge-bulk',
              description: 'Onze diensten ondersteunen u in het verzamelen van een staal dat een ware voorstelling is van de hele cargo.' +
              '<br/><br/>' +
              'Met onze gekeurde uitrusting en professionele werknemers zijn we in staat om voor u het correcte staal te nemen.',
              icons: [
                {
                  href: '/static/images/services/blue/vessel-barge.png',
                  description: 'Vaartuig / Binnenschip'
                },
                {
                  href: '/static/images/services/blue/silo.png',
                  description: 'Silo'
                },
                {
                  href: '/static/images/services/blue/warehouse.png',
                  description: 'Magazijn'
                },
                {
                  href: '/static/images/services/blue/container.png',
                  description: 'Container'
                }
              ]
            },
            {
              link: 'Medisch',
              href: 'medisch',
              description: 'Stalen in de healthcare sector vervoeren is niet eenvoudig. Bloed en biologische stalen vereisen extreme zorg bij het op de juiste temperatuur houden. Onze vervoersdienst kan vertragingen voorkomen om ervoor te zorgen dat resultaten niet gecompromitteerd worden. Met onze ervaring, reactie snelheid en 24/7 beschikbaarheid kunnen we u verzekeren dat uw stalen op tijd en in perfecte staat zullen arriveren.'
            },
            {
              link: 'Afvalwater',
              href: 'afvalwater',
              description: 'Persoonlijke veiligheid is het allerbelangrijkste! Staalname van afvalwater kan enkel gedaan worden door gekwalificeerd personeel. Onze werknemers zijn getraind en letten goed op om persoonlijke letsels van de bron van het staal of de plaats van het staalname punt te vermijden. Genomen stalen worden goed afgesloten, duidelijk gelabeld en veilig vervoerd (in gekoelde dozen indien nodig).'
            },
            {
              h5: 'Niet gevaarlijke producten'
            },
            {
              link: 'FOSFA - mineralen & vloeibare producten',
              href: 'fosfa-mineralen-vloeibare-producten',
              description: 'FOSFA materialen zijn uiterst delicaat. Contaminatie kan zich snel voordoen wanneer ongeschikt staalname materiaal gebruikt wordt. Met onze geteste FOSFA specifieke uitrusting kunnen we klanten verzekeren dat genomen stalen exact en betrouwbaar zijn. Of het nu gaat over granen, plantaardige oliën, zaden of andere levensmiddelen - QSDS can u helpen de kwaliteit van uw product te vrijwaren door representatieve stalen te nemen.',
              icons: [
                {
                  href: '/static/images/services/blue/vessel-barge.png',
                  description: 'Vaartuig / Binnenschip'
                },
                {
                  href: '/static/images/services/blue/silo.png',
                  description: 'Silo'
                },
                {
                  href: '/static/images/services/blue/warehouse.png',
                  description: 'Magazijn'
                },
                {
                  href: '/static/images/services/blue/container.png',
                  description: 'Container'
                },
                {
                  href: '/static/images/services/blue/shore-tank.png',
                  description: 'Land tank'
                },
                {
                  href: '/static/images/services/blue/truck.png',
                  description: 'Vrachtwagen'
                },
                {
                  href: '/static/images/services/blue/railcar.png',
                  description: 'Wagon'
                },
                {
                  href: '/static/images/services/blue/ibc.png',
                  description: 'IBC'
                }
              ]
            },
            {
              link: 'Bulk korrel of poeder',
              href: 'bulk-korrel-of-poeder',
              description: 'Om de kwaliteit van het eindproduct te vrijwaren moeten bulk korrels of poeders gestaald worden op regelmatige basis doorheen het verwerkingsproces. Onze staalname ingenieurs zijn opgeleid om de verschillende stappen doorheen het proces op te volgen en weten wanneer er stalen genomen moeten worden om het resultaat van het eindproduct te kunnen garanderen.',
              icons: [
                {
                  href: '/static/images/services/blue/vessel-barge.png',
                  description: 'Vaartuig / Binnenschip'
                },
                {
                  href: '/static/images/services/blue/silo.png',
                  description: 'Silo'
                },
                {
                  href: '/static/images/services/blue/warehouse.png',
                  description: 'Magazijn'
                }
              ]
            },
            {
              link: 'Milieu',
              href: 'milieu',
              description: 'Staalname van bodem of grondwater vereist gekwalificeerde handen. Een staal kan snel nutteloos worden als het niet genomen word door een deskundige professional met de geschikte uitrusting. Wij bieden diensten aan van het hoogste niveau. Ons hoofddoel is onze klanten te helpen bij het snel identifceren en verhelpen van eventuele obstakels. Contacteer ons om meer te weten over onze staalname en vervoers dienstverlening.',
              icons: [
                {
                  href: '/static/images/services/blue/soil.png',
                  description: 'Bodem'
                },
                {
                  href: '/static/images/services/blue/groundwater.png',
                  description: 'Grondwater'
                }
              ]
            }
          ]
          break
      }

      return {
        structure: structure
      }
    },
    section1: function() {
      let title = {
        _1: 'Empowering growth',
        _2: 'through our services'
      }


      switch (this.language.value) {
        case 'nl':
          title = {
            _1: 'Wij helpen u groeien',
            _2: 'door onze dienstverlening'
          }
      }

      return {
        title: title
      }
    }
  },
  components: {
    'TopMenu': TopMenu,
    'Footer': Footer
  },
  beforeMount() {
    const path = this.$route.path.split('/')
    let language = {
      text: '',
      value: ''
    }

    if (path.length > 0) {
      switch (path[1]) {
        case 'nl':
        case 'en':
          language.value = path[1]
          break
        default:
          /*for (let idx in navigator.languages) {
            const navLanguage = navigator.languages[idx]

            switch (navLanguage) {
              case 'nl':
              case 'en':
                language.value = navLanguage
                break
            }

            if (language.value !== '') {
              break
            }
          }*/

          if (language.value === '') {
            language.value = 'en'
          }
      }
    }

    switch (language.value) {
      case 'nl':
        language.text = 'Nederlands'
        break
      case 'en':
        language.text = 'English'
        break
    }

    this.$store.commit("language", language)
  }
}



// WEBPACK FOOTER //
// ./src/pages/page/services/services.js